import { c as he, f as pe, a as ve, q as It, b as me } from "./vue-router-WHGQH8Wm.mjs";
import { _ as ot, o as D, c as V, a as q, t as pt, d as Et, b as ge, F as Xt, r as Ct, e as vt, g as mt, h as ye } from "./index-B7bwkLWz.mjs";
var nt = { exports: {} };
var be = nt.exports, zt;
function we() {
  return zt || (zt = 1, (function(n, e) {
    (function(r, i) {
      n.exports = i();
    })(be, (function() {
      function r(s) {
        return r = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
          return typeof t;
        } : function(t) {
          return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
        }, r(s);
      }
      function i(s, t) {
        if (!(s instanceof t)) throw new TypeError("Cannot call a class as a function");
      }
      function l(s, t) {
        for (var c = 0; c < t.length; c++) {
          var o = t[c];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(s, o.key, o);
        }
      }
      function u(s, t, c) {
        return t && l(s.prototype, t), s;
      }
      function d(s) {
        return d = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
          return t.__proto__ || Object.getPrototypeOf(t);
        }, d(s);
      }
      function h(s, t) {
        return h = Object.setPrototypeOf || function(c, o) {
          return c.__proto__ = o, c;
        }, h(s, t);
      }
      function v(s, t) {
        if (t && (typeof t == "object" || typeof t == "function")) return t;
        if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return (function(c) {
          if (c === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          return c;
        })(s);
      }
      function y(s) {
        var t = (function() {
          if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
          if (typeof Proxy == "function") return !0;
          try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {
            }))), !0;
          } catch {
            return !1;
          }
        })();
        return function() {
          var c, o = d(s);
          if (t) {
            var a = d(this).constructor;
            c = Reflect.construct(o, arguments, a);
          } else c = o.apply(this, arguments);
          return v(this, c);
        };
      }
      function g(s, t) {
        for (; !Object.prototype.hasOwnProperty.call(s, t) && (s = d(s)) !== null; ) ;
        return s;
      }
      function w() {
        return w = typeof Reflect < "u" && Reflect.get ? Reflect.get : function(s, t, c) {
          var o = g(s, t);
          if (o) {
            var a = Object.getOwnPropertyDescriptor(o, t);
            return a.get ? a.get.call(arguments.length < 3 ? s : c) : a.value;
          }
        }, w.apply(this, arguments);
      }
      var _ = { type: "slider", startAt: 0, perView: 1, focusAt: 0, gap: 10, autoplay: !1, hoverpause: !0, keyboard: !0, bound: !1, swipeThreshold: 80, dragThreshold: 120, perSwipe: "", touchRatio: 0.5, touchAngle: 45, animationDuration: 400, rewind: !0, rewindDuration: 800, animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)", waitForTransition: !0, throttle: 10, direction: "ltr", peek: 0, cloningRatio: 1, breakpoints: {}, classes: { swipeable: "glide--swipeable", dragging: "glide--dragging", direction: { ltr: "glide--ltr", rtl: "glide--rtl" }, type: { slider: "glide--slider", carousel: "glide--carousel" }, slide: { clone: "glide__slide--clone", active: "glide__slide--active" }, arrow: { disabled: "glide__arrow--disabled" }, nav: { active: "glide__bullet--active" } } };
      function x(s) {
        console.error("[Glide warn]: ".concat(s));
      }
      function T(s) {
        return parseInt(s);
      }
      function M(s) {
        return typeof s == "string";
      }
      function j(s) {
        var t = r(s);
        return t === "function" || t === "object" && !!s;
      }
      function I(s) {
        return typeof s == "function";
      }
      function E(s) {
        return s === void 0;
      }
      function z(s) {
        return s.constructor === Array;
      }
      function J(s, t, c) {
        var o = {};
        for (var a in t) I(t[a]) ? o[a] = t[a](s, o, c) : x("Extension must be a function");
        for (var f in o) I(o[f].mount) && o[f].mount();
        return o;
      }
      function R(s, t, c) {
        Object.defineProperty(s, t, c);
      }
      function Q(s, t) {
        var c = Object.assign({}, s, t);
        return t.hasOwnProperty("classes") && (c.classes = Object.assign({}, s.classes, t.classes), t.classes.hasOwnProperty("direction") && (c.classes.direction = Object.assign({}, s.classes.direction, t.classes.direction)), t.classes.hasOwnProperty("type") && (c.classes.type = Object.assign({}, s.classes.type, t.classes.type)), t.classes.hasOwnProperty("slide") && (c.classes.slide = Object.assign({}, s.classes.slide, t.classes.slide)), t.classes.hasOwnProperty("arrow") && (c.classes.arrow = Object.assign({}, s.classes.arrow, t.classes.arrow)), t.classes.hasOwnProperty("nav") && (c.classes.nav = Object.assign({}, s.classes.nav, t.classes.nav))), t.hasOwnProperty("breakpoints") && (c.breakpoints = Object.assign({}, s.breakpoints, t.breakpoints)), c;
      }
      var Zt = (function() {
        function s() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          i(this, s), this.events = t, this.hop = t.hasOwnProperty;
        }
        return u(s, [{ key: "on", value: function(t, c) {
          if (!z(t)) {
            this.hop.call(this.events, t) || (this.events[t] = []);
            var o = this.events[t].push(c) - 1;
            return { remove: function() {
              delete this.events[t][o];
            } };
          }
          for (var a = 0; a < t.length; a++) this.on(t[a], c);
        } }, { key: "emit", value: function(t, c) {
          if (z(t)) for (var o = 0; o < t.length; o++) this.emit(t[o], c);
          else this.hop.call(this.events, t) && this.events[t].forEach((function(a) {
            a(c || {});
          }));
        } }]), s;
      })(), Gt = (function() {
        function s(t) {
          var c = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
          i(this, s), this._c = {}, this._t = [], this._e = new Zt(), this.disabled = !1, this.selector = t, this.settings = Q(_, c), this.index = this.settings.startAt;
        }
        return u(s, [{ key: "mount", value: function() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return this._e.emit("mount.before"), j(t) ? this._c = J(this, t, this._e) : x("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
        } }, { key: "mutate", value: function() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
          return z(t) ? this._t = t : x("You need to provide a array on `mutate()`"), this;
        } }, { key: "update", value: function() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return this.settings = Q(this.settings, t), t.hasOwnProperty("startAt") && (this.index = t.startAt), this._e.emit("update"), this;
        } }, { key: "go", value: function(t) {
          return this._c.Run.make(t), this;
        } }, { key: "move", value: function(t) {
          return this._c.Transition.disable(), this._c.Move.make(t), this;
        } }, { key: "destroy", value: function() {
          return this._e.emit("destroy"), this;
        } }, { key: "play", value: function() {
          var t = arguments.length > 0 && arguments[0] !== void 0 && arguments[0];
          return t && (this.settings.autoplay = t), this._e.emit("play"), this;
        } }, { key: "pause", value: function() {
          return this._e.emit("pause"), this;
        } }, { key: "disable", value: function() {
          return this.disabled = !0, this;
        } }, { key: "enable", value: function() {
          return this.disabled = !1, this;
        } }, { key: "on", value: function(t, c) {
          return this._e.on(t, c), this;
        } }, { key: "isType", value: function(t) {
          return this.settings.type === t;
        } }, { key: "settings", get: function() {
          return this._o;
        }, set: function(t) {
          j(t) ? this._o = t : x("Options must be an `object` instance.");
        } }, { key: "index", get: function() {
          return this._i;
        }, set: function(t) {
          this._i = T(t);
        } }, { key: "type", get: function() {
          return this.settings.type;
        } }, { key: "disabled", get: function() {
          return this._d;
        }, set: function(t) {
          this._d = !!t;
        } }]), s;
      })();
      function Tt() {
        return (/* @__PURE__ */ new Date()).getTime();
      }
      function Z(s, t, c) {
        var o, a, f, p, m = 0;
        c || (c = {});
        var S = function() {
          m = c.leading === !1 ? 0 : Tt(), o = null, p = s.apply(a, f), o || (a = f = null);
        }, O = function() {
          var k = Tt();
          m || c.leading !== !1 || (m = k);
          var b = t - (k - m);
          return a = this, f = arguments, b <= 0 || b > t ? (o && (clearTimeout(o), o = null), m = k, p = s.apply(a, f), o || (a = f = null)) : o || c.trailing === !1 || (o = setTimeout(S, b)), p;
        };
        return O.cancel = function() {
          clearTimeout(o), m = 0, o = a = f = null;
        }, O;
      }
      var lt = { ltr: ["marginLeft", "marginRight"], rtl: ["marginRight", "marginLeft"] };
      function Ot(s) {
        if (s && s.parentNode) {
          for (var t = s.parentNode.firstChild, c = []; t; t = t.nextSibling) t.nodeType === 1 && t !== s && c.push(t);
          return c;
        }
        return [];
      }
      function xt(s) {
        return !!(s && s instanceof window.HTMLElement);
      }
      function ft(s) {
        return Array.prototype.slice.call(s);
      }
      var Ht = '[data-glide-el="track"]', W = (function() {
        function s() {
          var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          i(this, s), this.listeners = t;
        }
        return u(s, [{ key: "on", value: function(t, c, o) {
          var a = arguments.length > 3 && arguments[3] !== void 0 && arguments[3];
          M(t) && (t = [t]);
          for (var f = 0; f < t.length; f++) this.listeners[t[f]] = o, c.addEventListener(t[f], this.listeners[t[f]], a);
        } }, { key: "off", value: function(t, c) {
          var o = arguments.length > 2 && arguments[2] !== void 0 && arguments[2];
          M(t) && (t = [t]);
          for (var a = 0; a < t.length; a++) c.removeEventListener(t[a], this.listeners[t[a]], o);
        } }, { key: "destroy", value: function() {
          delete this.listeners;
        } }]), s;
      })(), te = ["ltr", "rtl"], ee = { ">": "<", "<": ">", "=": "=" };
      function ne(s, t) {
        return { modify: function(c) {
          return t.Direction.is("rtl") ? -c : c;
        } };
      }
      function re(s, t) {
        return { modify: function(c) {
          var o = Math.floor(c / t.Sizes.slideWidth);
          return c + t.Gaps.value * o;
        } };
      }
      function ie(s, t) {
        return { modify: function(c) {
          return c + t.Clones.grow / 2;
        } };
      }
      function se(s, t) {
        return { modify: function(c) {
          if (s.settings.focusAt >= 0) {
            var o = t.Peek.value;
            return j(o) ? c - o.before : c - o;
          }
          return c;
        } };
      }
      function oe(s, t) {
        return { modify: function(c) {
          var o = t.Gaps.value, a = t.Sizes.width, f = s.settings.focusAt, p = t.Sizes.slideWidth;
          return f === "center" ? c - (a / 2 - p / 2) : c - p * f - o * f;
        } };
      }
      var At = !1;
      try {
        var Rt = Object.defineProperty({}, "passive", { get: function() {
          At = !0;
        } });
        window.addEventListener("testPassive", null, Rt), window.removeEventListener("testPassive", null, Rt);
      } catch {
      }
      var dt = At, G = ["touchstart", "mousedown"], Pt = ["touchmove", "mousemove"], Mt = ["touchend", "touchcancel", "mouseup", "mouseleave"], Lt = ["mousedown", "mousemove", "mouseup", "mouseleave"], ht = '[data-glide-el^="controls"]', ae = "".concat(ht, ' [data-glide-dir*="<"]'), ue = "".concat(ht, ' [data-glide-dir*=">"]');
      function jt(s) {
        return j(s) ? (t = s, Object.keys(t).sort().reduce((function(c, o) {
          return c[o] = t[o], c[o], c;
        }), {})) : (x("Breakpoints option must be an object"), {});
        var t;
      }
      var ce = { Html: function(s, t, c) {
        var o = { mount: function() {
          this.root = s.selector, this.track = this.root.querySelector(Ht), this.collectSlides();
        }, collectSlides: function() {
          this.slides = ft(this.wrapper.children).filter((function(a) {
            return !a.classList.contains(s.settings.classes.slide.clone);
          }));
        } };
        return R(o, "root", { get: function() {
          return o._r;
        }, set: function(a) {
          M(a) && (a = document.querySelector(a)), xt(a) ? o._r = a : x("Root element must be a existing Html node");
        } }), R(o, "track", { get: function() {
          return o._t;
        }, set: function(a) {
          xt(a) ? o._t = a : x("Could not find track element. Please use ".concat(Ht, " attribute."));
        } }), R(o, "wrapper", { get: function() {
          return o.track.children[0];
        } }), c.on("update", (function() {
          o.collectSlides();
        })), o;
      }, Translate: function(s, t, c) {
        var o = { set: function(a) {
          var f = (function(m, S, O) {
            var k = [re, ie, se, oe].concat(m._t, [ne]);
            return { mutate: function(b) {
              for (var H = 0; H < k.length; H++) {
                var A = k[H];
                I(A) && I(A().modify) ? b = A(m, S, O).modify(b) : x("Transformer should be a function that returns an object with `modify()` method");
              }
              return b;
            } };
          })(s, t).mutate(a), p = "translate3d(".concat(-1 * f, "px, 0px, 0px)");
          t.Html.wrapper.style.mozTransform = p, t.Html.wrapper.style.webkitTransform = p, t.Html.wrapper.style.transform = p;
        }, remove: function() {
          t.Html.wrapper.style.transform = "";
        }, getStartIndex: function() {
          var a = t.Sizes.length, f = s.index, p = s.settings.perView;
          return t.Run.isOffset(">") || t.Run.isOffset("|>") ? a + (f - p) : (f + p) % a;
        }, getTravelDistance: function() {
          var a = t.Sizes.slideWidth * s.settings.perView;
          return t.Run.isOffset(">") || t.Run.isOffset("|>") ? -1 * a : a;
        } };
        return c.on("move", (function(a) {
          if (!s.isType("carousel") || !t.Run.isOffset()) return o.set(a.movement);
          t.Transition.after((function() {
            c.emit("translate.jump"), o.set(t.Sizes.slideWidth * s.index);
          }));
          var f = t.Sizes.slideWidth * t.Translate.getStartIndex();
          return o.set(f - t.Translate.getTravelDistance());
        })), c.on("destroy", (function() {
          o.remove();
        })), o;
      }, Transition: function(s, t, c) {
        var o = !1, a = { compose: function(f) {
          var p = s.settings;
          return o ? "".concat(f, " 0ms ").concat(p.animationTimingFunc) : "".concat(f, " ").concat(this.duration, "ms ").concat(p.animationTimingFunc);
        }, set: function() {
          var f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
          t.Html.wrapper.style.transition = this.compose(f);
        }, remove: function() {
          t.Html.wrapper.style.transition = "";
        }, after: function(f) {
          setTimeout((function() {
            f();
          }), this.duration);
        }, enable: function() {
          o = !1, this.set();
        }, disable: function() {
          o = !0, this.set();
        } };
        return R(a, "duration", { get: function() {
          var f = s.settings;
          return s.isType("slider") && t.Run.offset ? f.rewindDuration : f.animationDuration;
        } }), c.on("move", (function() {
          a.set();
        })), c.on(["build.before", "resize", "translate.jump"], (function() {
          a.disable();
        })), c.on("run", (function() {
          a.enable();
        })), c.on("destroy", (function() {
          a.remove();
        })), a;
      }, Direction: function(s, t, c) {
        var o = { mount: function() {
          this.value = s.settings.direction;
        }, resolve: function(a) {
          var f = a.slice(0, 1);
          return this.is("rtl") ? a.split(f).join(ee[f]) : a;
        }, is: function(a) {
          return this.value === a;
        }, addClass: function() {
          t.Html.root.classList.add(s.settings.classes.direction[this.value]);
        }, removeClass: function() {
          t.Html.root.classList.remove(s.settings.classes.direction[this.value]);
        } };
        return R(o, "value", { get: function() {
          return o._v;
        }, set: function(a) {
          te.indexOf(a) > -1 ? o._v = a : x("Direction value must be `ltr` or `rtl`");
        } }), c.on(["destroy", "update"], (function() {
          o.removeClass();
        })), c.on("update", (function() {
          o.mount();
        })), c.on(["build.before", "update"], (function() {
          o.addClass();
        })), o;
      }, Peek: function(s, t, c) {
        var o = { mount: function() {
          this.value = s.settings.peek;
        } };
        return R(o, "value", { get: function() {
          return o._v;
        }, set: function(a) {
          j(a) ? (a.before = T(a.before), a.after = T(a.after)) : a = T(a), o._v = a;
        } }), R(o, "reductor", { get: function() {
          var a = o.value, f = s.settings.perView;
          return j(a) ? a.before / f + a.after / f : 2 * a / f;
        } }), c.on(["resize", "update"], (function() {
          o.mount();
        })), o;
      }, Sizes: function(s, t, c) {
        var o = { setupSlides: function() {
          for (var a = "".concat(this.slideWidth, "px"), f = t.Html.slides, p = 0; p < f.length; p++) f[p].style.width = a;
        }, setupWrapper: function() {
          t.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
        }, remove: function() {
          for (var a = t.Html.slides, f = 0; f < a.length; f++) a[f].style.width = "";
          t.Html.wrapper.style.width = "";
        } };
        return R(o, "length", { get: function() {
          return t.Html.slides.length;
        } }), R(o, "width", { get: function() {
          return t.Html.track.offsetWidth;
        } }), R(o, "wrapperSize", { get: function() {
          return o.slideWidth * o.length + t.Gaps.grow + t.Clones.grow;
        } }), R(o, "slideWidth", { get: function() {
          return o.width / s.settings.perView - t.Peek.reductor - t.Gaps.reductor;
        } }), c.on(["build.before", "resize", "update"], (function() {
          o.setupSlides(), o.setupWrapper();
        })), c.on("destroy", (function() {
          o.remove();
        })), o;
      }, Gaps: function(s, t, c) {
        var o = { apply: function(a) {
          for (var f = 0, p = a.length; f < p; f++) {
            var m = a[f].style, S = t.Direction.value;
            m[lt[S][0]] = f !== 0 ? "".concat(this.value / 2, "px") : "", f !== a.length - 1 ? m[lt[S][1]] = "".concat(this.value / 2, "px") : m[lt[S][1]] = "";
          }
        }, remove: function(a) {
          for (var f = 0, p = a.length; f < p; f++) {
            var m = a[f].style;
            m.marginLeft = "", m.marginRight = "";
          }
        } };
        return R(o, "value", { get: function() {
          return T(s.settings.gap);
        } }), R(o, "grow", { get: function() {
          return o.value * t.Sizes.length;
        } }), R(o, "reductor", { get: function() {
          var a = s.settings.perView;
          return o.value * (a - 1) / a;
        } }), c.on(["build.after", "update"], Z((function() {
          o.apply(t.Html.wrapper.children);
        }), 30)), c.on("destroy", (function() {
          o.remove(t.Html.wrapper.children);
        })), o;
      }, Move: function(s, t, c) {
        var o = { mount: function() {
          this._o = 0;
        }, make: function() {
          var a = this, f = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
          this.offset = f, c.emit("move", { movement: this.value }), t.Transition.after((function() {
            c.emit("move.after", { movement: a.value });
          }));
        } };
        return R(o, "offset", { get: function() {
          return o._o;
        }, set: function(a) {
          o._o = E(a) ? 0 : T(a);
        } }), R(o, "translate", { get: function() {
          return t.Sizes.slideWidth * s.index;
        } }), R(o, "value", { get: function() {
          var a = this.offset, f = this.translate;
          return t.Direction.is("rtl") ? f + a : f - a;
        } }), c.on(["build.before", "run"], (function() {
          o.make();
        })), o;
      }, Clones: function(s, t, c) {
        var o = { mount: function() {
          this.items = [], s.isType("carousel") && (this.items = this.collect());
        }, collect: function() {
          var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], f = t.Html.slides, p = s.settings, m = p.perView, S = p.classes, O = p.cloningRatio;
          if (f.length !== 0) for (var k = +!!s.settings.peek, b = m + k + Math.round(m / 2), H = f.slice(0, b).reverse(), A = f.slice(-1 * b), B = 0; B < Math.max(O, Math.floor(m / f.length)); B++) {
            for (var $ = 0; $ < H.length; $++) {
              var F = H[$].cloneNode(!0);
              F.classList.add(S.slide.clone), a.push(F);
            }
            for (var Y = 0; Y < A.length; Y++) {
              var C = A[Y].cloneNode(!0);
              C.classList.add(S.slide.clone), a.unshift(C);
            }
          }
          return a;
        }, append: function() {
          for (var a = this.items, f = t.Html, p = f.wrapper, m = f.slides, S = Math.floor(a.length / 2), O = a.slice(0, S).reverse(), k = a.slice(-1 * S).reverse(), b = "".concat(t.Sizes.slideWidth, "px"), H = 0; H < k.length; H++) p.appendChild(k[H]);
          for (var A = 0; A < O.length; A++) p.insertBefore(O[A], m[0]);
          for (var B = 0; B < a.length; B++) a[B].style.width = b;
        }, remove: function() {
          for (var a = this.items, f = 0; f < a.length; f++) t.Html.wrapper.removeChild(a[f]);
        } };
        return R(o, "grow", { get: function() {
          return (t.Sizes.slideWidth + t.Gaps.value) * o.items.length;
        } }), c.on("update", (function() {
          o.remove(), o.mount(), o.append();
        })), c.on("build.before", (function() {
          s.isType("carousel") && o.append();
        })), c.on("destroy", (function() {
          o.remove();
        })), o;
      }, Resize: function(s, t, c) {
        var o = new W(), a = { mount: function() {
          this.bind();
        }, bind: function() {
          o.on("resize", window, Z((function() {
            c.emit("resize");
          }), s.settings.throttle));
        }, unbind: function() {
          o.off("resize", window);
        } };
        return c.on("destroy", (function() {
          a.unbind(), o.destroy();
        })), a;
      }, Build: function(s, t, c) {
        var o = { mount: function() {
          c.emit("build.before"), this.typeClass(), this.activeClass(), c.emit("build.after");
        }, typeClass: function() {
          t.Html.root.classList.add(s.settings.classes.type[s.settings.type]);
        }, activeClass: function() {
          var a = s.settings.classes, f = t.Html.slides[s.index];
          f && (f.classList.add(a.slide.active), Ot(f).forEach((function(p) {
            p.classList.remove(a.slide.active);
          })));
        }, removeClasses: function() {
          var a = s.settings.classes, f = a.type, p = a.slide;
          t.Html.root.classList.remove(f[s.settings.type]), t.Html.slides.forEach((function(m) {
            m.classList.remove(p.active);
          }));
        } };
        return c.on(["destroy", "update"], (function() {
          o.removeClasses();
        })), c.on(["resize", "update"], (function() {
          o.mount();
        })), c.on("move.after", (function() {
          o.activeClass();
        })), o;
      }, Run: function(s, t, c) {
        var o = { mount: function() {
          this._o = !1;
        }, make: function(a) {
          var f = this;
          s.disabled || (!s.settings.waitForTransition || s.disable(), this.move = a, c.emit("run.before", this.move), this.calculate(), c.emit("run", this.move), t.Transition.after((function() {
            f.isStart() && c.emit("run.start", f.move), f.isEnd() && c.emit("run.end", f.move), f.isOffset() && (f._o = !1, c.emit("run.offset", f.move)), c.emit("run.after", f.move), s.enable();
          })));
        }, calculate: function() {
          var a = this.move, f = this.length, p = a.steps, m = a.direction, S = 1;
          if (m === "=") return s.settings.bound && T(p) > f ? void (s.index = f) : void (s.index = p);
          if (m !== ">" || p !== ">") if (m !== "<" || p !== "<") {
            if (m === "|" && (S = s.settings.perView || 1), m === ">" || m === "|" && p === ">") {
              var O = (function(b) {
                var H = s.index;
                return s.isType("carousel") ? H + b : H + (b - H % b);
              })(S);
              return O > f && (this._o = !0), void (s.index = (function(b, H) {
                var A = o.length;
                return b <= A ? b : s.isType("carousel") ? b - (A + 1) : s.settings.rewind ? o.isBound() && !o.isEnd() ? A : 0 : o.isBound() ? A : Math.floor(A / H) * H;
              })(O, S));
            }
            if (m === "<" || m === "|" && p === "<") {
              var k = (function(b) {
                var H = s.index;
                return s.isType("carousel") ? H - b : (Math.ceil(H / b) - 1) * b;
              })(S);
              return k < 0 && (this._o = !0), void (s.index = (function(b, H) {
                var A = o.length;
                return b >= 0 ? b : s.isType("carousel") ? b + (A + 1) : s.settings.rewind ? o.isBound() && o.isStart() ? A : Math.floor(A / H) * H : 0;
              })(k, S));
            }
            x("Invalid direction pattern [".concat(m).concat(p, "] has been used"));
          } else s.index = 0;
          else s.index = f;
        }, isStart: function() {
          return s.index <= 0;
        }, isEnd: function() {
          return s.index >= this.length;
        }, isOffset: function() {
          var a = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
          return a ? !!this._o && (a === "|>" ? this.move.direction === "|" && this.move.steps === ">" : a === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === a) : this._o;
        }, isBound: function() {
          return s.isType("slider") && s.settings.focusAt !== "center" && s.settings.bound;
        } };
        return R(o, "move", { get: function() {
          return this._m;
        }, set: function(a) {
          var f = a.substr(1);
          this._m = { direction: a.substr(0, 1), steps: f ? T(f) ? T(f) : f : 0 };
        } }), R(o, "length", { get: function() {
          var a = s.settings, f = t.Html.slides.length;
          return this.isBound() ? f - 1 - (T(a.perView) - 1) + T(a.focusAt) : f - 1;
        } }), R(o, "offset", { get: function() {
          return this._o;
        } }), o;
      }, Swipe: function(s, t, c) {
        var o = new W(), a = 0, f = 0, p = 0, m = !1, S = !!dt && { passive: !0 }, O = { mount: function() {
          this.bindSwipeStart();
        }, start: function(k) {
          if (!m && !s.disabled) {
            this.disable();
            var b = this.touches(k);
            a = null, f = T(b.pageX), p = T(b.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), c.emit("swipe.start");
          }
        }, move: function(k) {
          if (!s.disabled) {
            var b = s.settings, H = b.touchAngle, A = b.touchRatio, B = b.classes, $ = this.touches(k), F = T($.pageX) - f, Y = T($.pageY) - p, C = Math.abs(F << 2), Bt = Math.abs(Y << 2), fe = Math.sqrt(C + Bt), de = Math.sqrt(Bt);
            if (!(180 * (a = Math.asin(de / fe)) / Math.PI < H)) return !1;
            k.stopPropagation(), t.Move.make(F * parseFloat(A)), t.Html.root.classList.add(B.dragging), c.emit("swipe.move");
          }
        }, end: function(k) {
          if (!s.disabled) {
            var b = s.settings, H = b.perSwipe, A = b.touchAngle, B = b.classes, $ = this.touches(k), F = this.threshold(k), Y = $.pageX - f, C = 180 * a / Math.PI;
            this.enable(), Y > F && C < A ? t.Run.make(t.Direction.resolve("".concat(H, "<"))) : Y < -F && C < A ? t.Run.make(t.Direction.resolve("".concat(H, ">"))) : t.Move.make(), t.Html.root.classList.remove(B.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), c.emit("swipe.end");
          }
        }, bindSwipeStart: function() {
          var k = this, b = s.settings, H = b.swipeThreshold, A = b.dragThreshold;
          H && o.on(G[0], t.Html.wrapper, (function(B) {
            k.start(B);
          }), S), A && o.on(G[1], t.Html.wrapper, (function(B) {
            k.start(B);
          }), S);
        }, unbindSwipeStart: function() {
          o.off(G[0], t.Html.wrapper, S), o.off(G[1], t.Html.wrapper, S);
        }, bindSwipeMove: function() {
          var k = this;
          o.on(Pt, t.Html.wrapper, Z((function(b) {
            k.move(b);
          }), s.settings.throttle), S);
        }, unbindSwipeMove: function() {
          o.off(Pt, t.Html.wrapper, S);
        }, bindSwipeEnd: function() {
          var k = this;
          o.on(Mt, t.Html.wrapper, (function(b) {
            k.end(b);
          }));
        }, unbindSwipeEnd: function() {
          o.off(Mt, t.Html.wrapper);
        }, touches: function(k) {
          return Lt.indexOf(k.type) > -1 ? k : k.touches[0] || k.changedTouches[0];
        }, threshold: function(k) {
          var b = s.settings;
          return Lt.indexOf(k.type) > -1 ? b.dragThreshold : b.swipeThreshold;
        }, enable: function() {
          return m = !1, t.Transition.enable(), this;
        }, disable: function() {
          return m = !0, t.Transition.disable(), this;
        } };
        return c.on("build.after", (function() {
          t.Html.root.classList.add(s.settings.classes.swipeable);
        })), c.on("destroy", (function() {
          O.unbindSwipeStart(), O.unbindSwipeMove(), O.unbindSwipeEnd(), o.destroy();
        })), O;
      }, Images: function(s, t, c) {
        var o = new W(), a = { mount: function() {
          this.bind();
        }, bind: function() {
          o.on("dragstart", t.Html.wrapper, this.dragstart);
        }, unbind: function() {
          o.off("dragstart", t.Html.wrapper);
        }, dragstart: function(f) {
          f.preventDefault();
        } };
        return c.on("destroy", (function() {
          a.unbind(), o.destroy();
        })), a;
      }, Anchors: function(s, t, c) {
        var o = new W(), a = !1, f = !1, p = { mount: function() {
          this._a = t.Html.wrapper.querySelectorAll("a"), this.bind();
        }, bind: function() {
          o.on("click", t.Html.wrapper, this.click);
        }, unbind: function() {
          o.off("click", t.Html.wrapper);
        }, click: function(m) {
          f && (m.stopPropagation(), m.preventDefault());
        }, detach: function() {
          if (f = !0, !a) {
            for (var m = 0; m < this.items.length; m++) this.items[m].draggable = !1;
            a = !0;
          }
          return this;
        }, attach: function() {
          if (f = !1, a) {
            for (var m = 0; m < this.items.length; m++) this.items[m].draggable = !0;
            a = !1;
          }
          return this;
        } };
        return R(p, "items", { get: function() {
          return p._a;
        } }), c.on("swipe.move", (function() {
          p.detach();
        })), c.on("swipe.end", (function() {
          t.Transition.after((function() {
            p.attach();
          }));
        })), c.on("destroy", (function() {
          p.attach(), p.unbind(), o.destroy();
        })), p;
      }, Controls: function(s, t, c) {
        var o = new W(), a = !!dt && { passive: !0 }, f = { mount: function() {
          this._n = t.Html.root.querySelectorAll('[data-glide-el="controls[nav]"]'), this._c = t.Html.root.querySelectorAll(ht), this._arrowControls = { previous: t.Html.root.querySelectorAll(ae), next: t.Html.root.querySelectorAll(ue) }, this.addBindings();
        }, setActive: function() {
          for (var p = 0; p < this._n.length; p++) this.addClass(this._n[p].children);
        }, removeActive: function() {
          for (var p = 0; p < this._n.length; p++) this.removeClass(this._n[p].children);
        }, addClass: function(p) {
          var m = s.settings, S = p[s.index];
          S && S && (S.classList.add(m.classes.nav.active), Ot(S).forEach((function(O) {
            O.classList.remove(m.classes.nav.active);
          })));
        }, removeClass: function(p) {
          var m = p[s.index];
          m && m.classList.remove(s.settings.classes.nav.active);
        }, setArrowState: function() {
          if (!s.settings.rewind) {
            var p = f._arrowControls.next, m = f._arrowControls.previous;
            this.resetArrowState(p, m), s.index === 0 && this.disableArrow(m), s.index === t.Run.length && this.disableArrow(p);
          }
        }, resetArrowState: function() {
          for (var p = s.settings, m = arguments.length, S = new Array(m), O = 0; O < m; O++) S[O] = arguments[O];
          S.forEach((function(k) {
            ft(k).forEach((function(b) {
              b.classList.remove(p.classes.arrow.disabled);
            }));
          }));
        }, disableArrow: function() {
          for (var p = s.settings, m = arguments.length, S = new Array(m), O = 0; O < m; O++) S[O] = arguments[O];
          S.forEach((function(k) {
            ft(k).forEach((function(b) {
              b.classList.add(p.classes.arrow.disabled);
            }));
          }));
        }, addBindings: function() {
          for (var p = 0; p < this._c.length; p++) this.bind(this._c[p].children);
        }, removeBindings: function() {
          for (var p = 0; p < this._c.length; p++) this.unbind(this._c[p].children);
        }, bind: function(p) {
          for (var m = 0; m < p.length; m++) o.on("click", p[m], this.click), o.on("touchstart", p[m], this.click, a);
        }, unbind: function(p) {
          for (var m = 0; m < p.length; m++) o.off(["click", "touchstart"], p[m]);
        }, click: function(p) {
          dt || p.type !== "touchstart" || p.preventDefault();
          var m = p.currentTarget.getAttribute("data-glide-dir");
          t.Run.make(t.Direction.resolve(m));
        } };
        return R(f, "items", { get: function() {
          return f._c;
        } }), c.on(["mount.after", "move.after"], (function() {
          f.setActive();
        })), c.on(["mount.after", "run"], (function() {
          f.setArrowState();
        })), c.on("destroy", (function() {
          f.removeBindings(), f.removeActive(), o.destroy();
        })), f;
      }, Keyboard: function(s, t, c) {
        var o = new W(), a = { mount: function() {
          s.settings.keyboard && this.bind();
        }, bind: function() {
          o.on("keyup", document, this.press);
        }, unbind: function() {
          o.off("keyup", document);
        }, press: function(f) {
          var p = s.settings.perSwipe;
          f.code === "ArrowRight" && t.Run.make(t.Direction.resolve("".concat(p, ">"))), f.code === "ArrowLeft" && t.Run.make(t.Direction.resolve("".concat(p, "<")));
        } };
        return c.on(["destroy", "update"], (function() {
          a.unbind();
        })), c.on("update", (function() {
          a.mount();
        })), c.on("destroy", (function() {
          o.destroy();
        })), a;
      }, Autoplay: function(s, t, c) {
        var o = new W(), a = { mount: function() {
          this.enable(), this.start(), s.settings.hoverpause && this.bind();
        }, enable: function() {
          this._e = !0;
        }, disable: function() {
          this._e = !1;
        }, start: function() {
          var f = this;
          this._e && (this.enable(), s.settings.autoplay && E(this._i) && (this._i = setInterval((function() {
            f.stop(), t.Run.make(">"), f.start(), c.emit("autoplay");
          }), this.time)));
        }, stop: function() {
          this._i = clearInterval(this._i);
        }, bind: function() {
          var f = this;
          o.on("mouseover", t.Html.root, (function() {
            f._e && f.stop();
          })), o.on("mouseout", t.Html.root, (function() {
            f._e && f.start();
          }));
        }, unbind: function() {
          o.off(["mouseover", "mouseout"], t.Html.root);
        } };
        return R(a, "time", { get: function() {
          var f = t.Html.slides[s.index].getAttribute("data-glide-autoplay");
          return T(f || s.settings.autoplay);
        } }), c.on(["destroy", "update"], (function() {
          a.unbind();
        })), c.on(["run.before", "swipe.start", "update"], (function() {
          a.stop();
        })), c.on(["pause", "destroy"], (function() {
          a.disable(), a.stop();
        })), c.on(["run.after", "swipe.end"], (function() {
          a.start();
        })), c.on(["play"], (function() {
          a.enable(), a.start();
        })), c.on("update", (function() {
          a.mount();
        })), c.on("destroy", (function() {
          o.destroy();
        })), a;
      }, Breakpoints: function(s, t, c) {
        var o = new W(), a = s.settings, f = jt(a.breakpoints), p = Object.assign({}, a), m = { match: function(S) {
          if (window.matchMedia !== void 0) {
            for (var O in S) if (S.hasOwnProperty(O) && window.matchMedia("(max-width: ".concat(O, "px)")).matches) return S[O];
          }
          return p;
        } };
        return Object.assign(a, m.match(f)), o.on("resize", window, Z((function() {
          s.settings = Q(a, m.match(f));
        }), s.settings.throttle)), c.on("update", (function() {
          f = jt(f), p = Object.assign({}, a);
        })), c.on("destroy", (function() {
          o.off("resize", window);
        })), m;
      } }, le = (function(s) {
        (function(o, a) {
          if (typeof a != "function" && a !== null) throw new TypeError("Super expression must either be null or a function");
          o.prototype = Object.create(a && a.prototype, { constructor: { value: o, writable: !0, configurable: !0 } }), a && h(o, a);
        })(c, s);
        var t = y(c);
        function c() {
          return i(this, c), t.apply(this, arguments);
        }
        return u(c, [{ key: "mount", value: function() {
          var o = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
          return w(d(c.prototype), "mount", this).call(this, Object.assign({}, ce, o));
        } }]), c;
      })(Gt);
      return le;
    }));
  })(nt)), nt.exports;
}
we();
const _e = {
  name: "SimilarItem",
  props: {
    categoryId: {
      type: [Number, String],
      default: 1e3
    },
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    formattedPrice() {
      return pe(this.product.price);
    },
    priceText() {
      return he(this.product, this.categoryId);
    }
  }
}, Se = { class: "coop-c-product-card__container" }, ke = ["href"], Te = ["srcset"], Oe = ["src", "alt"], xe = {
  key: 0,
  class: "coop-u-category-card__details-price"
}, He = { key: 0 }, Ae = {
  key: 1,
  class: "coop-u-category-card__details-price"
};
function Re(n, e, r, i, l, u) {
  return D(), V("div", Se, [
    q("a", {
      href: r.product.url
    }, [
      q("picture", null, [
        q("source", {
          srcset: r.product.mainImage + "?fm=webp&q=60&w=295&h=200 295w, " + r.product.mainImage + "?fm=webp&q=60&w=590&h=400 590w",
          type: "image/webp",
          sizes: "295px"
        }, null, 8, Te),
        q("img", {
          class: "coop-c-product-card__card-image",
          "data-object-fit": "cover",
          src: r.product.mainImage + "?w=295&h=200&q=60",
          alt: r.product.title
        }, null, 8, Oe)
      ]),
      q("div", null, [
        q("h4", null, pt(r.product.title), 1)
      ]),
      r.product.price ? (D(), V("span", xe, [
        r.product.fromPrice ? (D(), V("span", He, pt(u.priceText), 1)) : Et("", !0),
        ge(" £" + pt(u.formattedPrice), 1)
      ])) : r.product.isPoa ? (D(), V("span", Ae, "Price available on request")) : Et("", !0)
    ], 8, ke)
  ]);
}
const Pe = /* @__PURE__ */ ot(_e, [["render", Re], ["__scopeId", "data-v-0dcd1df7"]]);
function rt(n) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? rt = function(e) {
    return typeof e;
  } : rt = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, rt(n);
}
function at(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Me(n, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(n, i.key, i);
  }
}
function ut(n, e, r) {
  return e && Me(n.prototype, e), n;
}
function Le(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: n,
      writable: !0,
      configurable: !0
    }
  }), e && gt(n, e);
}
function K(n) {
  return K = Object.setPrototypeOf ? Object.getPrototypeOf : function(r) {
    return r.__proto__ || Object.getPrototypeOf(r);
  }, K(n);
}
function gt(n, e) {
  return gt = Object.setPrototypeOf || function(i, l) {
    return i.__proto__ = l, i;
  }, gt(n, e);
}
function je() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Be(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Ie(n, e) {
  if (e && (typeof e == "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Be(n);
}
function Ee(n) {
  var e = je();
  return function() {
    var i = K(n), l;
    if (e) {
      var u = K(this).constructor;
      l = Reflect.construct(i, arguments, u);
    } else
      l = i.apply(this, arguments);
    return Ie(this, l);
  };
}
function ze(n, e) {
  for (; !Object.prototype.hasOwnProperty.call(n, e) && (n = K(n), n !== null); )
    ;
  return n;
}
function it() {
  return typeof Reflect < "u" && Reflect.get ? it = Reflect.get : it = function(e, r, i) {
    var l = ze(e, r);
    if (l) {
      var u = Object.getOwnPropertyDescriptor(l, r);
      return u.get ? u.get.call(arguments.length < 3 ? e : i) : u.value;
    }
  }, it.apply(this, arguments);
}
var De = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: "slider",
  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,
  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,
  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,
  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,
  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: !1,
  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: !0,
  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: !0,
  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: !1,
  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,
  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,
  /**
   * A number of slides moved on single swipe.
   *
   * Available types:
   * `` - Moves slider by one slide per swipe
   * `|` - Moves slider between views per swipe (number of slides defined in `perView` options)
   *
   * @type {String}
   */
  perSwipe: "",
  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,
  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,
  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,
  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: !0,
  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,
  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: "cubic-bezier(.165, .840, .440, 1)",
  /**
   * Wait for the animation to finish until the next user input can be processed
   *
   * @type {boolean}
   */
  waitForTransition: !0,
  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,
  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: "ltr",
  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,
  /**
   * Defines how many clones of current viewport will be generated.
   *
   * @type {Number}
   */
  cloningRatio: 1,
  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},
  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    swipeable: "glide--swipeable",
    dragging: "glide--dragging",
    direction: {
      ltr: "glide--ltr",
      rtl: "glide--rtl"
    },
    type: {
      slider: "glide--slider",
      carousel: "glide--carousel"
    },
    slide: {
      clone: "glide__slide--clone",
      active: "glide__slide--active"
    },
    arrow: {
      disabled: "glide__arrow--disabled"
    },
    nav: {
      active: "glide__bullet--active"
    }
  }
};
function N(n) {
  console.error("[Glide warn]: ".concat(n));
}
function L(n) {
  return parseInt(n);
}
function Ve(n) {
  return parseFloat(n);
}
function yt(n) {
  return typeof n == "string";
}
function U(n) {
  var e = rt(n);
  return e === "function" || e === "object" && !!n;
}
function st(n) {
  return typeof n == "function";
}
function Kt(n) {
  return typeof n > "u";
}
function bt(n) {
  return n.constructor === Array;
}
function qe(n, e, r) {
  var i = {};
  for (var l in e)
    st(e[l]) ? i[l] = e[l](n, i, r) : N("Extension must be a function");
  for (var u in i)
    st(i[u].mount) && i[u].mount();
  return i;
}
function P(n, e, r) {
  Object.defineProperty(n, e, r);
}
function Ne(n) {
  return Object.keys(n).sort().reduce(function(e, r) {
    return e[r] = n[r], e[r], e;
  }, {});
}
function wt(n, e) {
  var r = Object.assign({}, n, e);
  return e.hasOwnProperty("classes") && (r.classes = Object.assign({}, n.classes, e.classes), e.classes.hasOwnProperty("direction") && (r.classes.direction = Object.assign({}, n.classes.direction, e.classes.direction)), e.classes.hasOwnProperty("type") && (r.classes.type = Object.assign({}, n.classes.type, e.classes.type)), e.classes.hasOwnProperty("slide") && (r.classes.slide = Object.assign({}, n.classes.slide, e.classes.slide)), e.classes.hasOwnProperty("arrow") && (r.classes.arrow = Object.assign({}, n.classes.arrow, e.classes.arrow)), e.classes.hasOwnProperty("nav") && (r.classes.nav = Object.assign({}, n.classes.nav, e.classes.nav))), e.hasOwnProperty("breakpoints") && (r.breakpoints = Object.assign({}, n.breakpoints, e.breakpoints)), r;
}
var We = /* @__PURE__ */ (function() {
  function n() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    at(this, n), this.events = e, this.hop = e.hasOwnProperty;
  }
  return ut(n, [{
    key: "on",
    value: function(r, i) {
      if (bt(r)) {
        for (var l = 0; l < r.length; l++)
          this.on(r[l], i);
        return;
      }
      this.hop.call(this.events, r) || (this.events[r] = []);
      var u = this.events[r].push(i) - 1;
      return {
        remove: function() {
          delete this.events[r][u];
        }
      };
    }
    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */
  }, {
    key: "emit",
    value: function(r, i) {
      if (bt(r)) {
        for (var l = 0; l < r.length; l++)
          this.emit(r[l], i);
        return;
      }
      this.hop.call(this.events, r) && this.events[r].forEach(function(u) {
        u(i || {});
      });
    }
  }]), n;
})(), $e = /* @__PURE__ */ (function() {
  function n(e) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    at(this, n), this._c = {}, this._t = [], this._e = new We(), this.disabled = !1, this.selector = e, this.settings = wt(De, r), this.index = this.settings.startAt;
  }
  return ut(n, [{
    key: "mount",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this._e.emit("mount.before"), U(r) ? this._c = qe(this, r, this._e) : N("You need to provide a object on `mount()`"), this._e.emit("mount.after"), this;
    }
    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */
  }, {
    key: "mutate",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
      return bt(r) ? this._t = r : N("You need to provide a array on `mutate()`"), this;
    }
    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */
  }, {
    key: "update",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return this.settings = wt(this.settings, r), r.hasOwnProperty("startAt") && (this.index = r.startAt), this._e.emit("update"), this;
    }
    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     * `|>` - Move one viewport forward
     * `|<` - Move one viewport backward
     *
     * @param {String} pattern
     * @return {Glide}
     */
  }, {
    key: "go",
    value: function(r) {
      return this._c.Run.make(r), this;
    }
    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */
  }, {
    key: "move",
    value: function(r) {
      return this._c.Transition.disable(), this._c.Move.make(r), this;
    }
    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */
  }, {
    key: "destroy",
    value: function() {
      return this._e.emit("destroy"), this;
    }
    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */
  }, {
    key: "play",
    value: function() {
      var r = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
      return r && (this.settings.autoplay = r), this._e.emit("play"), this;
    }
    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */
  }, {
    key: "pause",
    value: function() {
      return this._e.emit("pause"), this;
    }
    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */
  }, {
    key: "disable",
    value: function() {
      return this.disabled = !0, this;
    }
    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */
  }, {
    key: "enable",
    value: function() {
      return this.disabled = !1, this;
    }
    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */
  }, {
    key: "on",
    value: function(r, i) {
      return this._e.on(r, i), this;
    }
    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */
  }, {
    key: "isType",
    value: function(r) {
      return this.settings.type === r;
    }
    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */
  }, {
    key: "settings",
    get: function() {
      return this._o;
    },
    set: function(r) {
      U(r) ? this._o = r : N("Options must be an `object` instance.");
    }
    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */
  }, {
    key: "index",
    get: function() {
      return this._i;
    },
    set: function(r) {
      this._i = L(r);
    }
    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */
  }, {
    key: "type",
    get: function() {
      return this.settings.type;
    }
    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */
  }, {
    key: "disabled",
    get: function() {
      return this._d;
    },
    set: function(r) {
      this._d = !!r;
    }
  }]), n;
})();
function Fe(n, e, r) {
  var i = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function() {
      this._o = !1;
    },
    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function(y) {
      var g = this;
      n.disabled || (!n.settings.waitForTransition || n.disable(), this.move = y, r.emit("run.before", this.move), this.calculate(), r.emit("run", this.move), e.Transition.after(function() {
        g.isStart() && r.emit("run.start", g.move), g.isEnd() && r.emit("run.end", g.move), g.isOffset() && (g._o = !1, r.emit("run.offset", g.move)), r.emit("run.after", g.move), n.enable();
      }));
    },
    /**
     * Calculates current index based on defined move.
     *
     * @return {Number|Undefined}
     */
    calculate: function() {
      var y = this.move, g = this.length, w = y.steps, _ = y.direction, x = 1;
      if (_ === "=") {
        if (n.settings.bound && L(w) > g) {
          n.index = g;
          return;
        }
        n.index = w;
        return;
      }
      if (_ === ">" && w === ">") {
        n.index = g;
        return;
      }
      if (_ === "<" && w === "<") {
        n.index = 0;
        return;
      }
      if (_ === "|" && (x = n.settings.perView || 1), _ === ">" || _ === "|" && w === ">") {
        var T = l(x);
        T > g && (this._o = !0), n.index = u(T, x);
        return;
      }
      if (_ === "<" || _ === "|" && w === "<") {
        var M = d(x);
        M < 0 && (this._o = !0), n.index = h(M, x);
        return;
      }
      N("Invalid direction pattern [".concat(_).concat(w, "] has been used"));
    },
    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function() {
      return n.index <= 0;
    },
    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function() {
      return n.index >= this.length;
    },
    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function() {
      var y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : void 0;
      return y ? this._o ? y === "|>" ? this.move.direction === "|" && this.move.steps === ">" : y === "|<" ? this.move.direction === "|" && this.move.steps === "<" : this.move.direction === y : !1 : this._o;
    },
    /**
     * Checks if bound mode is active
     *
     * @return {Boolean}
     */
    isBound: function() {
      return n.isType("slider") && n.settings.focusAt !== "center" && n.settings.bound;
    }
  };
  function l(v) {
    var y = n.index;
    return n.isType("carousel") ? y + v : y + (v - y % v);
  }
  function u(v, y) {
    var g = i.length;
    return v <= g ? v : n.isType("carousel") ? v - (g + 1) : n.settings.rewind ? i.isBound() && !i.isEnd() ? g : 0 : i.isBound() ? g : Math.floor(g / y) * y;
  }
  function d(v) {
    var y = n.index;
    if (n.isType("carousel"))
      return y - v;
    var g = Math.ceil(y / v);
    return (g - 1) * v;
  }
  function h(v, y) {
    var g = i.length;
    return v >= 0 ? v : n.isType("carousel") ? v + (g + 1) : n.settings.rewind ? i.isBound() && i.isStart() ? g : Math.floor(g / y) * y : 0;
  }
  return P(i, "move", {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function() {
      return this._m;
    },
    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function(y) {
      var g = y.substr(1);
      this._m = {
        direction: y.substr(0, 1),
        steps: g ? L(g) ? L(g) : g : 0
      };
    }
  }), P(i, "length", {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function() {
      var y = n.settings, g = e.Html.slides.length;
      return this.isBound() ? g - 1 - (L(y.perView) - 1) + L(y.focusAt) : g - 1;
    }
  }), P(i, "offset", {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function() {
      return this._o;
    }
  }), i;
}
function Dt() {
  return (/* @__PURE__ */ new Date()).getTime();
}
function ct(n, e, r) {
  var i, l, u, d, h = 0;
  r || (r = {});
  var v = function() {
    h = r.leading === !1 ? 0 : Dt(), i = null, d = n.apply(l, u), i || (l = u = null);
  }, y = function() {
    var w = Dt();
    !h && r.leading === !1 && (h = w);
    var _ = e - (w - h);
    return l = this, u = arguments, _ <= 0 || _ > e ? (i && (clearTimeout(i), i = null), h = w, d = n.apply(l, u), i || (l = u = null)) : !i && r.trailing !== !1 && (i = setTimeout(v, _)), d;
  };
  return y.cancel = function() {
    clearTimeout(i), h = 0, i = l = u = null;
  }, y;
}
var tt = {
  ltr: ["marginLeft", "marginRight"],
  rtl: ["marginRight", "marginLeft"]
};
function Ye(n, e, r) {
  var i = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function(u) {
      for (var d = 0, h = u.length; d < h; d++) {
        var v = u[d].style, y = e.Direction.value;
        d !== 0 ? v[tt[y][0]] = "".concat(this.value / 2, "px") : v[tt[y][0]] = "", d !== u.length - 1 ? v[tt[y][1]] = "".concat(this.value / 2, "px") : v[tt[y][1]] = "";
      }
    },
    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function(u) {
      for (var d = 0, h = u.length; d < h; d++) {
        var v = u[d].style;
        v.marginLeft = "", v.marginRight = "";
      }
    }
  };
  return P(i, "value", {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function() {
      return L(n.settings.gap);
    }
  }), P(i, "grow", {
    /**
     * Gets additional dimensions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function() {
      return i.value * e.Sizes.length;
    }
  }), P(i, "reductor", {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function() {
      var u = n.settings.perView;
      return i.value * (u - 1) / u;
    }
  }), r.on(["build.after", "update"], ct(function() {
    i.apply(e.Html.wrapper.children);
  }, 30)), r.on("destroy", function() {
    i.remove(e.Html.wrapper.children);
  }), i;
}
function Ut(n) {
  if (n && n.parentNode) {
    for (var e = n.parentNode.firstChild, r = []; e; e = e.nextSibling)
      e.nodeType === 1 && e !== n && r.push(e);
    return r;
  }
  return [];
}
function Vt(n) {
  return !!(n && n instanceof window.HTMLElement);
}
function _t(n) {
  return Array.prototype.slice.call(n);
}
var qt = '[data-glide-el="track"]';
function Xe(n, e, r) {
  var i = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function() {
      this.root = n.selector, this.track = this.root.querySelector(qt), this.collectSlides();
    },
    /**
     * Collect slides
     */
    collectSlides: function() {
      this.slides = _t(this.wrapper.children).filter(function(u) {
        return !u.classList.contains(n.settings.classes.slide.clone);
      });
    }
  };
  return P(i, "root", {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function() {
      return i._r;
    },
    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function(u) {
      yt(u) && (u = document.querySelector(u)), Vt(u) ? i._r = u : N("Root element must be a existing Html node");
    }
  }), P(i, "track", {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function() {
      return i._t;
    },
    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function(u) {
      Vt(u) ? i._t = u : N("Could not find track element. Please use ".concat(qt, " attribute."));
    }
  }), P(i, "wrapper", {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function() {
      return i.track.children[0];
    }
  }), r.on("update", function() {
    i.collectSlides();
  }), i;
}
function Ce(n, e, r) {
  var i = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = n.settings.peek;
    }
  };
  return P(i, "value", {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function() {
      return i._v;
    },
    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function(u) {
      U(u) ? (u.before = L(u.before), u.after = L(u.after)) : u = L(u), i._v = u;
    }
  }), P(i, "reductor", {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function() {
      var u = i.value, d = n.settings.perView;
      return U(u) ? u.before / d + u.after / d : u * 2 / d;
    }
  }), r.on(["resize", "update"], function() {
    i.mount();
  }), i;
}
function Ke(n, e, r) {
  var i = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._o = 0;
    },
    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function() {
      var u = this, d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
      this.offset = d, r.emit("move", {
        movement: this.value
      }), e.Transition.after(function() {
        r.emit("move.after", {
          movement: u.value
        });
      });
    }
  };
  return P(i, "offset", {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function() {
      return i._o;
    },
    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function(u) {
      i._o = Kt(u) ? 0 : L(u);
    }
  }), P(i, "translate", {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function() {
      return e.Sizes.slideWidth * n.index;
    }
  }), P(i, "value", {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function() {
      var u = this.offset, d = this.translate;
      return e.Direction.is("rtl") ? d + u : d - u;
    }
  }), r.on(["build.before", "run"], function() {
    i.make();
  }), i;
}
function Ue(n, e, r) {
  var i = {
    /**
     * Setups dimensions of slides.
     *
     * @return {Void}
     */
    setupSlides: function() {
      for (var u = "".concat(this.slideWidth, "px"), d = e.Html.slides, h = 0; h < d.length; h++)
        d[h].style.width = u;
    },
    /**
     * Setups dimensions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function() {
      e.Html.wrapper.style.width = "".concat(this.wrapperSize, "px");
    },
    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function() {
      for (var u = e.Html.slides, d = 0; d < u.length; d++)
        u[d].style.width = "";
      e.Html.wrapper.style.width = "";
    }
  };
  return P(i, "length", {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function() {
      return e.Html.slides.length;
    }
  }), P(i, "width", {
    /**
     * Gets width value of the slider (visible area).
     *
     * @return {Number}
     */
    get: function() {
      return e.Html.track.offsetWidth;
    }
  }), P(i, "wrapperSize", {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function() {
      return i.slideWidth * i.length + e.Gaps.grow + e.Clones.grow;
    }
  }), P(i, "slideWidth", {
    /**
     * Gets width value of a single slide.
     *
     * @return {Number}
     */
    get: function() {
      return i.width / n.settings.perView - e.Peek.reductor - e.Gaps.reductor;
    }
  }), r.on(["build.before", "resize", "update"], function() {
    i.setupSlides(), i.setupWrapper();
  }), r.on("destroy", function() {
    i.remove();
  }), i;
}
function Qe(n, e, r) {
  var i = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function() {
      r.emit("build.before"), this.typeClass(), this.activeClass(), r.emit("build.after");
    },
    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function() {
      e.Html.root.classList.add(n.settings.classes.type[n.settings.type]);
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function() {
      var u = n.settings.classes, d = e.Html.slides[n.index];
      d && (d.classList.add(u.slide.active), Ut(d).forEach(function(h) {
        h.classList.remove(u.slide.active);
      }));
    },
    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function() {
      var u = n.settings.classes, d = u.type, h = u.slide;
      e.Html.root.classList.remove(d[n.settings.type]), e.Html.slides.forEach(function(v) {
        v.classList.remove(h.active);
      });
    }
  };
  return r.on(["destroy", "update"], function() {
    i.removeClasses();
  }), r.on(["resize", "update"], function() {
    i.mount();
  }), r.on("move.after", function() {
    i.activeClass();
  }), i;
}
function Je(n, e, r) {
  var i = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function() {
      this.items = [], n.isType("carousel") && (this.items = this.collect());
    },
    /**
     * Collect clones with pattern.
     *
     * @return {[]}
     */
    collect: function() {
      var u = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], d = e.Html.slides, h = n.settings, v = h.perView, y = h.classes, g = h.cloningRatio;
      if (d.length !== 0)
        for (var w = +!!n.settings.peek, _ = v + w + Math.round(v / 2), x = d.slice(0, _).reverse(), T = d.slice(_ * -1), M = 0; M < Math.max(g, Math.floor(v / d.length)); M++) {
          for (var j = 0; j < x.length; j++) {
            var I = x[j].cloneNode(!0);
            I.classList.add(y.slide.clone), u.push(I);
          }
          for (var E = 0; E < T.length; E++) {
            var z = T[E].cloneNode(!0);
            z.classList.add(y.slide.clone), u.unshift(z);
          }
        }
      return u;
    },
    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function() {
      for (var u = this.items, d = e.Html, h = d.wrapper, v = d.slides, y = Math.floor(u.length / 2), g = u.slice(0, y).reverse(), w = u.slice(y * -1).reverse(), _ = "".concat(e.Sizes.slideWidth, "px"), x = 0; x < w.length; x++)
        h.appendChild(w[x]);
      for (var T = 0; T < g.length; T++)
        h.insertBefore(g[T], v[0]);
      for (var M = 0; M < u.length; M++)
        u[M].style.width = _;
    },
    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function() {
      for (var u = this.items, d = 0; d < u.length; d++)
        e.Html.wrapper.removeChild(u[d]);
    }
  };
  return P(i, "grow", {
    /**
     * Gets additional dimensions value caused by clones.
     *
     * @return {Number}
     */
    get: function() {
      return (e.Sizes.slideWidth + e.Gaps.value) * i.items.length;
    }
  }), r.on("update", function() {
    i.remove(), i.mount(), i.append();
  }), r.on("build.before", function() {
    n.isType("carousel") && i.append();
  }), r.on("destroy", function() {
    i.remove();
  }), i;
}
var X = /* @__PURE__ */ (function() {
  function n() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    at(this, n), this.listeners = e;
  }
  return ut(n, [{
    key: "on",
    value: function(r, i, l) {
      var u = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
      yt(r) && (r = [r]);
      for (var d = 0; d < r.length; d++)
        this.listeners[r[d]] = l, i.addEventListener(r[d], this.listeners[r[d]], u);
    }
    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */
  }, {
    key: "off",
    value: function(r, i) {
      var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
      yt(r) && (r = [r]);
      for (var u = 0; u < r.length; u++)
        i.removeEventListener(r[u], this.listeners[r[u]], l);
    }
    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */
  }, {
    key: "destroy",
    value: function() {
      delete this.listeners;
    }
  }]), n;
})();
function Ze(n, e, r) {
  var i = new X(), l = {
    /**
     * Initializes window bindings.
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("resize", window, ct(function() {
        r.emit("resize");
      }, n.settings.throttle));
    },
    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("resize", window);
    }
  };
  return r.on("destroy", function() {
    l.unbind(), i.destroy();
  }), l;
}
var Ge = ["ltr", "rtl"], tn = {
  ">": "<",
  "<": ">",
  "=": "="
};
function en(n, e, r) {
  var i = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function() {
      this.value = n.settings.direction;
    },
    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function(u) {
      var d = u.slice(0, 1);
      return this.is("rtl") ? u.split(d).join(tn[d]) : u;
    },
    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function(u) {
      return this.value === u;
    },
    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function() {
      e.Html.root.classList.add(n.settings.classes.direction[this.value]);
    },
    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function() {
      e.Html.root.classList.remove(n.settings.classes.direction[this.value]);
    }
  };
  return P(i, "value", {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function() {
      return i._v;
    },
    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function(u) {
      Ge.indexOf(u) > -1 ? i._v = u : N("Direction value must be `ltr` or `rtl`");
    }
  }), r.on(["destroy", "update"], function() {
    i.removeClass();
  }), r.on("update", function() {
    i.mount();
  }), r.on(["build.before", "update"], function() {
    i.addClass();
  }), i;
}
function nn(n, e) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      return e.Direction.is("rtl") ? -i : i;
    }
  };
}
function rn(n, e) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      var l = Math.floor(i / e.Sizes.slideWidth);
      return i + e.Gaps.value * l;
    }
  };
}
function sn(n, e) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      return i + e.Clones.grow / 2;
    }
  };
}
function on(n, e) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      if (n.settings.focusAt >= 0) {
        var l = e.Peek.value;
        return U(l) ? i - l.before : i - l;
      }
      return i;
    }
  };
}
function an(n, e) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function(i) {
      var l = e.Gaps.value, u = e.Sizes.width, d = n.settings.focusAt, h = e.Sizes.slideWidth;
      return d === "center" ? i - (u / 2 - h / 2) : i - h * d - l * d;
    }
  };
}
function un(n, e, r) {
  var i = [rn, sn, on, an].concat(n._t, [nn]);
  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function(u) {
      for (var d = 0; d < i.length; d++) {
        var h = i[d];
        st(h) && st(h().modify) ? u = h(n, e, r).modify(u) : N("Transformer should be a function that returns an object with `modify()` method");
      }
      return u;
    }
  };
}
function cn(n, e, r) {
  var i = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function(u) {
      var d = un(n, e).mutate(u), h = "translate3d(".concat(-1 * d, "px, 0px, 0px)");
      e.Html.wrapper.style.mozTransform = h, e.Html.wrapper.style.webkitTransform = h, e.Html.wrapper.style.transform = h;
    },
    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      e.Html.wrapper.style.transform = "";
    },
    /**
     * @return {number}
     */
    getStartIndex: function() {
      var u = e.Sizes.length, d = n.index, h = n.settings.perView;
      return e.Run.isOffset(">") || e.Run.isOffset("|>") ? u + (d - h) : (d + h) % u;
    },
    /**
     * @return {number}
     */
    getTravelDistance: function() {
      var u = e.Sizes.slideWidth * n.settings.perView;
      return e.Run.isOffset(">") || e.Run.isOffset("|>") ? u * -1 : u;
    }
  };
  return r.on("move", function(l) {
    if (!n.isType("carousel") || !e.Run.isOffset())
      return i.set(l.movement);
    e.Transition.after(function() {
      r.emit("translate.jump"), i.set(e.Sizes.slideWidth * n.index);
    });
    var u = e.Sizes.slideWidth * e.Translate.getStartIndex();
    return i.set(u - e.Translate.getTravelDistance());
  }), r.on("destroy", function() {
    i.remove();
  }), i;
}
function ln(n, e, r) {
  var i = !1, l = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function(d) {
      var h = n.settings;
      return i ? "".concat(d, " 0ms ").concat(h.animationTimingFunc) : "".concat(d, " ").concat(this.duration, "ms ").concat(h.animationTimingFunc);
    },
    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function() {
      var d = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
      e.Html.wrapper.style.transition = this.compose(d);
    },
    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function() {
      e.Html.wrapper.style.transition = "";
    },
    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function(d) {
      setTimeout(function() {
        d();
      }, this.duration);
    },
    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function() {
      i = !1, this.set();
    },
    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function() {
      i = !0, this.set();
    }
  };
  return P(l, "duration", {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function() {
      var d = n.settings;
      return n.isType("slider") && e.Run.offset ? d.rewindDuration : d.animationDuration;
    }
  }), r.on("move", function() {
    l.set();
  }), r.on(["build.before", "resize", "translate.jump"], function() {
    l.disable();
  }), r.on("run", function() {
    l.enable();
  }), r.on("destroy", function() {
    l.remove();
  }), l;
}
var Qt = !1;
try {
  var Nt = Object.defineProperty({}, "passive", {
    get: function() {
      Qt = !0;
    }
  });
  window.addEventListener("testPassive", null, Nt), window.removeEventListener("testPassive", null, Nt);
} catch {
}
var St = Qt, et = ["touchstart", "mousedown"], Wt = ["touchmove", "mousemove"], $t = ["touchend", "touchcancel", "mouseup", "mouseleave"], Ft = ["mousedown", "mousemove", "mouseup", "mouseleave"];
function fn(n, e, r) {
  var i = new X(), l = 0, u = 0, d = 0, h = !1, v = St ? {
    passive: !0
  } : !1, y = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function() {
      this.bindSwipeStart();
    },
    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function(w) {
      if (!h && !n.disabled) {
        this.disable();
        var _ = this.touches(w);
        l = null, u = L(_.pageX), d = L(_.pageY), this.bindSwipeMove(), this.bindSwipeEnd(), r.emit("swipe.start");
      }
    },
    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function(w) {
      if (!n.disabled) {
        var _ = n.settings, x = _.touchAngle, T = _.touchRatio, M = _.classes, j = this.touches(w), I = L(j.pageX) - u, E = L(j.pageY) - d, z = Math.abs(I << 2), J = Math.abs(E << 2), R = Math.sqrt(z + J), Q = Math.sqrt(J);
        if (l = Math.asin(Q / R), l * 180 / Math.PI < x)
          w.stopPropagation(), e.Move.make(I * Ve(T)), e.Html.root.classList.add(M.dragging), r.emit("swipe.move");
        else
          return !1;
      }
    },
    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function(w) {
      if (!n.disabled) {
        var _ = n.settings, x = _.perSwipe, T = _.touchAngle, M = _.classes, j = this.touches(w), I = this.threshold(w), E = j.pageX - u, z = l * 180 / Math.PI;
        this.enable(), E > I && z < T ? e.Run.make(e.Direction.resolve("".concat(x, "<"))) : E < -I && z < T ? e.Run.make(e.Direction.resolve("".concat(x, ">"))) : e.Move.make(), e.Html.root.classList.remove(M.dragging), this.unbindSwipeMove(), this.unbindSwipeEnd(), r.emit("swipe.end");
      }
    },
    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function() {
      var w = this, _ = n.settings, x = _.swipeThreshold, T = _.dragThreshold;
      x && i.on(et[0], e.Html.wrapper, function(M) {
        w.start(M);
      }, v), T && i.on(et[1], e.Html.wrapper, function(M) {
        w.start(M);
      }, v);
    },
    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function() {
      i.off(et[0], e.Html.wrapper, v), i.off(et[1], e.Html.wrapper, v);
    },
    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function() {
      var w = this;
      i.on(Wt, e.Html.wrapper, ct(function(_) {
        w.move(_);
      }, n.settings.throttle), v);
    },
    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function() {
      i.off(Wt, e.Html.wrapper, v);
    },
    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function() {
      var w = this;
      i.on($t, e.Html.wrapper, function(_) {
        w.end(_);
      });
    },
    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function() {
      i.off($t, e.Html.wrapper);
    },
    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function(w) {
      return Ft.indexOf(w.type) > -1 ? w : w.touches[0] || w.changedTouches[0];
    },
    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function(w) {
      var _ = n.settings;
      return Ft.indexOf(w.type) > -1 ? _.dragThreshold : _.swipeThreshold;
    },
    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function() {
      return h = !1, e.Transition.enable(), this;
    },
    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function() {
      return h = !0, e.Transition.disable(), this;
    }
  };
  return r.on("build.after", function() {
    e.Html.root.classList.add(n.settings.classes.swipeable);
  }), r.on("destroy", function() {
    y.unbindSwipeStart(), y.unbindSwipeMove(), y.unbindSwipeEnd(), i.destroy();
  }), y;
}
function dn(n, e, r) {
  var i = new X(), l = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function() {
      this.bind();
    },
    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("dragstart", e.Html.wrapper, this.dragstart);
    },
    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("dragstart", e.Html.wrapper);
    },
    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function(d) {
      d.preventDefault();
    }
  };
  return r.on("destroy", function() {
    l.unbind(), i.destroy();
  }), l;
}
function hn(n, e, r) {
  var i = new X(), l = !1, u = !1, d = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function() {
      this._a = e.Html.wrapper.querySelectorAll("a"), this.bind();
    },
    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("click", e.Html.wrapper, this.click);
    },
    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("click", e.Html.wrapper);
    },
    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function(v) {
      u && (v.stopPropagation(), v.preventDefault());
    },
    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function() {
      if (u = !0, !l) {
        for (var v = 0; v < this.items.length; v++)
          this.items[v].draggable = !1;
        l = !0;
      }
      return this;
    },
    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function() {
      if (u = !1, l) {
        for (var v = 0; v < this.items.length; v++)
          this.items[v].draggable = !0;
        l = !1;
      }
      return this;
    }
  };
  return P(d, "items", {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return d._a;
    }
  }), r.on("swipe.move", function() {
    d.detach();
  }), r.on("swipe.end", function() {
    e.Transition.after(function() {
      d.attach();
    });
  }), r.on("destroy", function() {
    d.attach(), d.unbind(), i.destroy();
  }), d;
}
var pn = '[data-glide-el="controls[nav]"]', kt = '[data-glide-el^="controls"]', vn = "".concat(kt, ' [data-glide-dir*="<"]'), mn = "".concat(kt, ' [data-glide-dir*=">"]');
function gn(n, e, r) {
  var i = new X(), l = St ? {
    passive: !0
  } : !1, u = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function() {
      this._n = e.Html.root.querySelectorAll(pn), this._c = e.Html.root.querySelectorAll(kt), this._arrowControls = {
        previous: e.Html.root.querySelectorAll(vn),
        next: e.Html.root.querySelectorAll(mn)
      }, this.addBindings();
    },
    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.addClass(this._n[h].children);
    },
    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function() {
      for (var h = 0; h < this._n.length; h++)
        this.removeClass(this._n[h].children);
    },
    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function(h) {
      var v = n.settings, y = h[n.index];
      y && y && (y.classList.add(v.classes.nav.active), Ut(y).forEach(function(g) {
        g.classList.remove(v.classes.nav.active);
      }));
    },
    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function(h) {
      var v = h[n.index];
      v && v.classList.remove(n.settings.classes.nav.active);
    },
    /**
     * Calculates, removes or adds `Glide.settings.classes.disabledArrow` class on the control arrows
     */
    setArrowState: function() {
      if (!n.settings.rewind) {
        var h = u._arrowControls.next, v = u._arrowControls.previous;
        this.resetArrowState(h, v), n.index === 0 && this.disableArrow(v), n.index === e.Run.length && this.disableArrow(h);
      }
    },
    /**
     * Removes `Glide.settings.classes.disabledArrow` from given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    resetArrowState: function() {
      for (var h = n.settings, v = arguments.length, y = new Array(v), g = 0; g < v; g++)
        y[g] = arguments[g];
      y.forEach(function(w) {
        _t(w).forEach(function(_) {
          _.classList.remove(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds `Glide.settings.classes.disabledArrow` to given NodeList elements
     *
     * @param {NodeList[]} lists
     */
    disableArrow: function() {
      for (var h = n.settings, v = arguments.length, y = new Array(v), g = 0; g < v; g++)
        y[g] = arguments[g];
      y.forEach(function(w) {
        _t(w).forEach(function(_) {
          _.classList.add(h.classes.arrow.disabled);
        });
      });
    },
    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.bind(this._c[h].children);
    },
    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function() {
      for (var h = 0; h < this._c.length; h++)
        this.unbind(this._c[h].children);
    },
    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function(h) {
      for (var v = 0; v < h.length; v++)
        i.on("click", h[v], this.click), i.on("touchstart", h[v], this.click, l);
    },
    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function(h) {
      for (var v = 0; v < h.length; v++)
        i.off(["click", "touchstart"], h[v]);
    },
    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in direction given via the
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {void}
     */
    click: function(h) {
      !St && h.type === "touchstart" && h.preventDefault();
      var v = h.currentTarget.getAttribute("data-glide-dir");
      e.Run.make(e.Direction.resolve(v));
    }
  };
  return P(u, "items", {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function() {
      return u._c;
    }
  }), r.on(["mount.after", "move.after"], function() {
    u.setActive();
  }), r.on(["mount.after", "run"], function() {
    u.setArrowState();
  }), r.on("destroy", function() {
    u.removeBindings(), u.removeActive(), i.destroy();
  }), u;
}
function yn(n, e, r) {
  var i = new X(), l = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function() {
      n.settings.keyboard && this.bind();
    },
    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function() {
      i.on("keyup", document, this.press);
    },
    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function() {
      i.off("keyup", document);
    },
    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function(d) {
      var h = n.settings.perSwipe;
      d.code === "ArrowRight" && e.Run.make(e.Direction.resolve("".concat(h, ">"))), d.code === "ArrowLeft" && e.Run.make(e.Direction.resolve("".concat(h, "<")));
    }
  };
  return r.on(["destroy", "update"], function() {
    l.unbind();
  }), r.on("update", function() {
    l.mount();
  }), r.on("destroy", function() {
    i.destroy();
  }), l;
}
function bn(n, e, r) {
  var i = new X(), l = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function() {
      this.enable(), this.start(), n.settings.hoverpause && this.bind();
    },
    /**
     * Enables autoplaying
     *
     * @returns {Void}
     */
    enable: function() {
      this._e = !0;
    },
    /**
     * Disables autoplaying.
     *
     * @returns {Void}
     */
    disable: function() {
      this._e = !1;
    },
    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function() {
      var d = this;
      this._e && (this.enable(), n.settings.autoplay && Kt(this._i) && (this._i = setInterval(function() {
        d.stop(), e.Run.make(">"), d.start(), r.emit("autoplay");
      }, this.time)));
    },
    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function() {
      this._i = clearInterval(this._i);
    },
    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function() {
      var d = this;
      i.on("mouseover", e.Html.root, function() {
        d._e && d.stop();
      }), i.on("mouseout", e.Html.root, function() {
        d._e && d.start();
      });
    },
    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function() {
      i.off(["mouseover", "mouseout"], e.Html.root);
    }
  };
  return P(l, "time", {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function() {
      var d = e.Html.slides[n.index].getAttribute("data-glide-autoplay");
      return L(d || n.settings.autoplay);
    }
  }), r.on(["destroy", "update"], function() {
    l.unbind();
  }), r.on(["run.before", "swipe.start", "update"], function() {
    l.stop();
  }), r.on(["pause", "destroy"], function() {
    l.disable(), l.stop();
  }), r.on(["run.after", "swipe.end"], function() {
    l.start();
  }), r.on(["play"], function() {
    l.enable(), l.start();
  }), r.on("update", function() {
    l.mount();
  }), r.on("destroy", function() {
    i.destroy();
  }), l;
}
function Yt(n) {
  return U(n) ? Ne(n) : (N("Breakpoints option must be an object"), {});
}
function wn(n, e, r) {
  var i = new X(), l = n.settings, u = Yt(l.breakpoints), d = Object.assign({}, l), h = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function(y) {
      if (typeof window.matchMedia < "u") {
        for (var g in y)
          if (y.hasOwnProperty(g) && window.matchMedia("(max-width: ".concat(g, "px)")).matches)
            return y[g];
      }
      return d;
    }
  };
  return Object.assign(l, h.match(u)), i.on("resize", window, ct(function() {
    n.settings = wt(l, h.match(u));
  }, n.settings.throttle)), r.on("update", function() {
    u = Yt(u), d = Object.assign({}, l);
  }), r.on("destroy", function() {
    i.off("resize", window);
  }), h;
}
var _n = {
  // Required
  Html: Xe,
  Translate: cn,
  Transition: ln,
  Direction: en,
  Peek: Ce,
  Sizes: Ue,
  Gaps: Ye,
  Move: Ke,
  Clones: Je,
  Resize: Ze,
  Build: Qe,
  Run: Fe,
  // Optional
  Swipe: fn,
  Images: dn,
  Anchors: hn,
  Controls: gn,
  Keyboard: yn,
  Autoplay: bn,
  Breakpoints: wn
}, Sn = /* @__PURE__ */ (function(n) {
  Le(r, n);
  var e = Ee(r);
  function r() {
    return at(this, r), e.apply(this, arguments);
  }
  return ut(r, [{
    key: "mount",
    value: function() {
      var l = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      return it(K(r.prototype), "mount", this).call(this, Object.assign({}, _n, l));
    }
  }]), r;
})($e);
const kn = {
  name: "GlideBullets",
  props: {
    slides: {
      type: Array,
      default: () => []
    }
  }
}, Tn = {
  class: "coop-c-glide-bullets",
  "data-glide-el": "controls[nav]"
}, On = ["data-glide-dir", "aria-label"];
function xn(n, e, r, i, l, u) {
  return D(), V("div", Tn, [
    (D(!0), V(Xt, null, Ct(r.slides, (d, h) => (D(), V("button", {
      key: h,
      class: "coop-c-glide-bullet glide__bullet",
      "data-glide-dir": "=" + h,
      "aria-label": `Go to slide ${h + 1} of ${r.slides.length}`
    }, null, 8, On))), 128))
  ]);
}
const Hn = /* @__PURE__ */ ot(kn, [["render", xn], ["__scopeId", "data-v-bcf39c84"]]), An = {
  name: "SimilarItemsGlider",
  components: {
    SimilarItem: Pe,
    GlideBullets: Hn
  },
  data() {
    return {
      categoryId: window.CATEGORYID ? window.CATEGORYID : 1e3,
      products: [],
      glider: {}
    };
  },
  computed: {
    url() {
      return window.PRODUCTS_API_URL || "https://api.funeral.coop.co.uk/products";
    },
    apiToken() {
      return window.PRODUCTS_API_TOKEN || "";
    }
  },
  created() {
    this.fetchProducts(), this.glider = new Sn(".glide", {
      type: "slider",
      perView: 4,
      // peek: {
      //   before: 0,
      //   after: 100
      // },
      // focusAt: "center",
      breakpoints: {
        1200: {
          perView: 3.5
        },
        1100: {
          perView: 3
        },
        900: {
          perView: 2.5
        },
        700: {
          perView: 2
        },
        600: {
          perView: 1.75
        },
        500: {
          perView: 1.5
        },
        430: {
          perView: 1.25
        },
        375: {
          perView: 1
        }
      }
    });
  },
  methods: {
    fetchProducts() {
      const n = new XMLHttpRequest(), e = this;
      n.addEventListener("load", function() {
        const r = JSON.parse(this.responseText);
        e.products = r.products.slice(0, 10), e.$nextTick(function() {
          this.glider.mount(), this.fixObjectFit();
        });
      }), n.open("GET", `${e.url}?category=${e.categoryId}`), n.setRequestHeader("x-api-key", e.apiToken), n.send();
    },
    fixObjectFit() {
      window.MSInputMethodContext && document.documentMode && document.querySelectorAll("img[data-object-fit]").forEach((e) => {
        (e.runtimeStyle || e.style).background = `url("${e.src}") no-repeat 0%/${e.currentStyle ? e.currentStyle["object-fit"] : e.getAttribute("data-object-fit")}`, e.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='${e.width}' height='${e.height}'%3E%3C/svg%3E`;
      });
    }
  }
}, Rn = { class: "coop-c-similar-items-glider__container" }, Pn = { class: "glide" }, Mn = {
  "data-glide-el": "track",
  class: "glide__track"
}, Ln = { class: "glide__slides" };
function jn(n, e, r, i, l, u) {
  const d = vt("SimilarItem"), h = vt("GlideBullets");
  return D(), V("div", Rn, [
    e[0] || (e[0] = q("h2", null, "Similar items", -1)),
    q("div", Pn, [
      q("div", Mn, [
        q("ul", Ln, [
          (D(!0), V(Xt, null, Ct(l.products, (v, y) => (D(), V("li", {
            key: y,
            class: "glide__slide"
          }, [
            mt(d, {
              "category-id": l.categoryId,
              product: v
            }, null, 8, ["category-id", "product"])
          ]))), 128))
        ])
      ]),
      mt(h, { slides: l.products }, null, 8, ["slides"])
    ])
  ]);
}
const Bn = /* @__PURE__ */ ot(An, [["render", jn], ["__scopeId", "data-v-22abfd73"]]), In = {
  name: "App",
  components: {
    SimilarItemsGlider: Bn
  }
}, En = { class: "coop-l-container" };
function zn(n, e, r, i, l, u) {
  const d = vt("SimilarItemsGlider");
  return D(), V("div", En, [
    mt(d)
  ]);
}
const Jt = /* @__PURE__ */ ot(In, [["render", zn]]), Dn = ve({
  history: me("/"),
  routes: [
    {
      path: window.location.pathname,
      component: Jt,
      props: (n) => ({
        name: n.query.name,
        query: n.query.query,
        page: n.query.page
      })
    }
  ],
  parseQuery(n) {
    return It.parse(n);
  },
  stringifyQuery(n) {
    return It.stringify(n);
  }
});
ye(Jt).use(Dn).mount("#app");
